module.exports = __webpack_public_path__ + "static/media/eyeSlash.9b5ecfbc.png";